import { Dispatch, SetStateAction, useState } from 'react';
import { useDebounce } from 'react-use';

function useDebouncedState<S>(initialState: S, ms: number): [S, S, Dispatch<SetStateAction<S>>] {
  const [debouncedValue, setDebouncedValue] = useState(initialState);
  const [actualValue, setActualValue] = useState(initialState);

  useDebounce(() => setDebouncedValue(actualValue), ms, [actualValue]);

  return [debouncedValue, actualValue, setActualValue];
}

export default useDebouncedState;
